import { render } from "./TeamActionsOverview.vue?vue&type=template&id=1b91bdca"
import script from "./TeamActionsOverview.vue?vue&type=script&lang=js"
export * from "./TeamActionsOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__